import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

/**
 * PageSkeleton — generic fallback (used as default in Suspense)
 * Looks like: Header + Hero Banner + 3 cards
 */
const PageSkeleton = () => {
  return (
    <div className="sk-page">
      <SkeletonBox className="sk-header" />
      <SkeletonBox className="sk-hero" />
      <div className="conatiner">
        <SkeletonBox className="sk-section-title" />
        <SkeletonBox className="sk-section-sub" />
        <div className="sk-home-grid">
          <SkeletonBox className="sk-home-grid-card" />
          <SkeletonBox className="sk-home-grid-card" />
          <SkeletonBox className="sk-home-grid-card" />
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
